import { debounce as d } from 'lodash'

export const debounce = d
